import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    standalone: true,
    selector: 'appbasecomponent',
    template: `
	<router-outlet></router-outlet>
	<router-outlet name="homeContent"></router-outlet>
	`,
    imports: [RouterModule],
})
// GIB-70 [Defect] 前端程式在不是AOT狀態下編譯無法正常使用
export class AppBaseComponent implements OnInit {

    constructor(private router: Router) {
        // console.log('CotComponent constructor...');
    }

    ngOnInit() {
        // console.log('CotComponent init...');
    }

}
